import ScrollToErrors from 'app/modules/scrollto-errors';
import 'launch/lib/jquery.jqbrowser.uncompressed.js';
import 'launch/lib/jquery.mailcheck.min.js';

$(function () {
    ScrollToErrors.attachTo(document);
});



// WEBPACK FOOTER //
// ./src/web/js/launch/layout.js